// Popup.js
import React, { useEffect } from 'react';
import './Popup.css'; // Import the CSS file
import { useNavigate } from 'react-router-dom';  // Import useNavigate

const PopupWindow = ({ message, type, onClose }) => {
    const navigate = useNavigate();  // Initialize navigate hook

    // Determine the popup type (success or error)
    const popupClass = type === 'success' ? 'popup-success' : 'popup-error';
    const iconClass = type === 'success' ? 'popup-success-icon' : 'popup-error-icon';
    const icon = type === 'success' ? 'fa-check' : 'fa-times'; // Font Awesome icon classes

    // useEffect(() => {
    //     // Navigate to home ("/") if it's an error and the popup is closed
    //     if (type === 'error') {
    //         const timeoutId = setTimeout(() => {
    //             navigate("/login");  // Navigate to home
    //             sessionStorage.removeItem("key-data")
    //             localStorage.removeItem("authUser")
    //             sessionStorage.removeItem("headers")
    //             sessionStorage.removeItem("menuData")
    //         }, 3000); // Wait for 3 seconds before redirecting (or adjust timing)

    //         return () => clearTimeout(timeoutId); // Cleanup the timeout if the component is unmounted
    //     }
    // }, [type, navigate]);

    return (
        <div className="popup-overlay" onClick={onClose}>
            <div className={`popup-container ${popupClass}`} onClick={(e) => e.stopPropagation()}>
                {/* Icon above the message */}
                <div className={`popup-icon ${iconClass}`}>
                    <i className={`fas ${icon}`}></i>
                </div>

                {/* Message and Close Button */}
                <p>{message}</p>
                <button className="popup-button" onClick={onClose}>
                    OK
                </button>
            </div>
        </div>
    );
};

export default PopupWindow;
